import { BusinessIndicator, getBusinessIndicator } from '@/entities/businessIndicator';
import { BusinessIndicatorService } from '@/services/BusinessIndicatorService';
import { useEffect, useState } from 'react';

export const useBusinessIndicator = () => {
  const [ businessIndicators, setBusinessIndicators ] = useState<getBusinessIndicator[]>([]);
  const [errorCreateBusinessIndicators, setErrorCreateBusinessIndicators] = useState(false);
  const [errorUpdateBusinessIndicators, setErrorUpdateBusinessIndicators] = useState(false);
  
  useEffect(()=>{
    const  fetchBusinessIndicators = async () => {
      try{
        const response = await BusinessIndicatorService.getBusinessIndicator();
        if(response){
          const indicatores = response.map((i:any)=>({
            id:i.id,
            businessId:i.businessId,
            indicatorId:i.indicatorId,
            commission:i.commission
          }));
          setBusinessIndicators(indicatores);
        }
    
      }catch(e){
        console.error(`Error ao carregar dados ${e}`);
      }
                    
    };
    
    fetchBusinessIndicators();
  },[]);

  const createBusinessIndicator = async (businessIndicator: BusinessIndicator)=>{
    try{
      await BusinessIndicatorService.createBusinessIndicator(businessIndicator);
    }catch(e){
      console.error(`Deu erro meu chapa ${e}`);
      setErrorCreateBusinessIndicators(true);
    }
  };

  const updateBusinessIndicatorId = async (businessId: number, indicatorId: number) => {
    try {
      await BusinessIndicatorService.updateBusinessIndicatorId(businessId,indicatorId);
    } catch (e) {
      console.log(`${e}`);
    }
  }
    
  const updateBusinessIndicator = async (businessId:number, businessIndicator:BusinessIndicator) => {
    try{
      await BusinessIndicatorService.updateBusinessIndicator(businessId, businessIndicator);
    }catch(e){
      console.error(`Deu erro meu chapa ${e}`);
      setErrorUpdateBusinessIndicators(true);
    }
  };

  const deleteBusinessIndicator = async (id:number, businessId:number) => {
    try{
      await BusinessIndicatorService.deleteBusinessIndicator(id, businessId);
    }catch(e){
      console.error(`Deu erro meu chapa ${e}`);
    }
  };

  return{
    businessIndicators,
    updateBusinessIndicatorId,
    createBusinessIndicator,
    updateBusinessIndicator,
    deleteBusinessIndicator
  };
};
